/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Day_KcalInputs */

const en_features_day_kcal = /** @type {(inputs: Features_Day_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories today`)
};

const pl_features_day_kcal = /** @type {(inputs: Features_Day_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie dziś`)
};

/**
* | output |
* | --- |
* | "Calories today" |
*
* @param {Features_Day_KcalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_kcal = /** @type {((inputs?: Features_Day_KcalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_KcalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_kcal(inputs)
	return en_features_day_kcal(inputs)
});